export default __webpack_public_path__ + "locales/sq-AL/ChangeEmailDialog.json?hash=dda83e9b5c2f3210d8734ff482ef2448";